import axios, { AxiosRequestConfig } from "axios";
import { errorHandler } from "./errorHandler";

export const apiRequest = async <T>(
  method: "get" | "post" | "patch" | "delete",
  url: string,
  config: AxiosRequestConfig = {},
  includeAuth: boolean = true,
): Promise<T> => {
  try {
    const token = localStorage.getItem("token");

    const { data } = await axios({
      method,
      url: `${process.env.REACT_APP_API_BASE_URL}${url}`,
      headers: {
        ...(includeAuth && token ? { Authorization: `Bearer ${token}` } : {}),
        ...(config.headers || {}),
      },
      ...config,
    });

    return data;
  } catch (error) {
    errorHandler(error);
    throw new Error("API request failed");
  }
};
